import $ from "jquery";

import select2 from "select2";
select2($);
import "select2/dist/css/select2.css";

var itemHeights = [];
var returnHeight;

$(function () {
  $(".user-profile__contents").each(function () {
    var thisHeight = $(this).height();
    itemHeights.push(thisHeight);
    $(this).addClass("is-hide");
    returnHeight = $(this).height();
  });
});

$(".user-profile__grad-trigger").on("click", function () {
  if (!$(this).hasClass("is-show")) {
    var index = $(this).index(".user-profile__grad-trigger");
    var addHeight = itemHeights[index];
    $(this)
      .addClass("is-show")
      .next()
      .animate({ height: addHeight }, 200)
      .removeClass("is-hide");
  } else {
    $(this)
      .removeClass("is-show")
      .next()
      .animate({ height: returnHeight }, 200)
      .addClass("is-hide");
  }
});

// プロフィールページ経歴書（スキルシート）アップロード
$("#profile-notification__content__btn").on("click", function () {
  $("#profile-notification__content__file-field").click();
  return false;
});

$("#profile-notification__content__file-field").on("change", function (e) {
  if (e.target.files[0].size > 0) {
    $(this).parents("form").submit();
  }
});

$.formatResultForGroupedTag = function formatResultForGroupedTag(state) {
  const count = $(state.element).attr("data-count") - 0;
  if (isNaN(count) || count == 0) return $(`<span>${state.text}</span>`);
  else
    return $(
      `<span class="select2-option-cover"><span class="select2-option-name">${state.text}</span><span class="select2-option-count">案件数: ${count}</span></span>`
    );
};

$('p.recommended-tags input[type="button"]').on("click", function () {
  const $this = $(this);
  const $parent = $this.parent();
  const value = $this.attr("data-value");
  const $target = $($parent.attr("data-target"));
  $target.val(value).trigger("change");
});

$("select[data-tag-level]").on("change", function () {
  const $this = $(this);
  const $level = $($this.attr("data-tag-level"));
  $level.focus();
});
